import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom'
import {toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  MDBBtn,
  MDBCard,
  MDBCardBody,
  MDBInput,
  MDBContainer,
  MDBRow,
  MDBValidation,
  MDBValidationItem,
  MDBCardTitle,
  MDBCardText


}
from 'mdb-react-ui-kit';
import '../../../css/index.css';
import SearchBar from '../../searchBar/searchBar';



function CriarEscola() {
  const navigate = useNavigate();

  const util = require('../../../utils/index');
  const userLogin = util.getUser();
  const api = require('../../../apis/escola')


  const handleSubmit = async (values) => { 

    values.preventDefault();
    util.isSubmitting()
    const result = await api.registrarEscolaApi(formValue);
    result ? toast.success("Criado com sucesso!") && navigate("/area-escola") : null;
    util.isSubmitting()
    
  }
  

  const [formValue, setFormValue] = useState({
    idEscola: '', 
    nomeEscola: '', 
    login: '', 
    senha: ''
  });
  
 
  const onChange = (e) => {
    if (e.target.name === 'idEscola'){
      if (!/^\d*$/.test(e.target.value)) {
        return;
    }
    }
    setFormValue({
       ...formValue, 
       [e.target.name]: 
       e.target.value });
  };

  const onBlur = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };

  return (
    <MDBContainer fluid className=' background-radial-gradient' style={{
      height:"100vh", minHeight:'500px',display:"flex", justifyContent:"center", alignItems:"center"
      
      }}>
      <MDBRow center className='w-100 d-flex flex-column align-items-center'>

          <MDBCard className='bg-dark text-white h-75 w-75' style={{borderRadius: '1rem', minWidth: '300px'}}>
              <MDBCardBody className='d-flex flex-column align-items-center'>

              <MDBCardTitle className='text-white my-5'>Bem vindo, {userLogin.nomeusuario}</MDBCardTitle>
                  <MDBValidation className='w-100' onSubmit={handleSubmit}>
                    <div className='d-flex justify-content-between'>
                    <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite uma coligada válida!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='Coligada' id='formControIdEscola' 
                          type='numeric' 
                          size="lg" 
                          style={{color:"white"}}
                          name='idEscola'
                          value={formValue.idEscola || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          minLength={3}
                          
                          />
                        
                      </MDBValidationItem>
                      <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite o nome da marca!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          labelClass='text-white' 
                          label='Nome da marca' 
                          name='nomeEscola'
                          id='formControNomeEscola' 
                          type='text' 
                          size="lg"
                          value={formValue.nomeEscola || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          style={{color:"white"}}/>
                      </MDBValidationItem >
                    
                    </div>
                    <div className='d-flex justify-content-between'>
                      <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite o login!' invalid>
                        <MDBInput 
                          wrapperClass='w-100' 
                          labelClass='text-white' 
                          label='Login' 
                          name='login'
                          id='formControLogin' 
                          type='text' 
                          size="lg"
                          value={formValue.login || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          style={{color:"white"}}/>
                          
                        
                   
                      </MDBValidationItem >
                      <MDBValidationItem style={{width:'45%'}} feedback='Por favor digite uma senha válida!' invalid>
                        <MDBInput 
                          wrapperClass='mb-5 w-100' 
                          className='bg-dark'
                          labelClass='text-white' 
                          label='Senha' id='formControSenha' 
                          type='password' 
                          size="lg" 
                          style={{color:"white"}}
                          name='senha'
                          value={formValue.senha || ''}
                          onChange={onChange}
                          onBlur={onBlur} 
                          required
                          minLength={3}
                          />
                        
                      </MDBValidationItem>

                    </div>
                    <div className='my-5'>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 btn-home' 
                        color='white' 
                        size='lg'
                        type='submit'   
                        id='submitForm'>
                        
                        Registrar
                      </MDBBtn>
                      <MDBBtn 
                        outline 
                        className='px-5 w-100 mt-4 btn-home' 
                        color='white' 
                        size='sm'
                        type='submit'   
                        onClick={() => {
                          navigate("/area-escola")
                        }}
                        >
                        
                        Voltar
                      </MDBBtn>
                    </div>
                  </MDBValidation>
              </MDBCardBody>
          </MDBCard>
      </MDBRow>

    </MDBContainer>
  );
}

export default CriarEscola;